module.exports = __webpack_public_path__ + "img/hipercard.3d516b0.svg";